module.exports = __webpack_public_path__ + "static/img/Uwland.03270f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Uwland.jpg
// module id = 6nV/
// module chunks = 0